import { Col, Games, Input, Row, ShoutoutsRow, Spinner2 } from 'components';
import { Api, updateGames } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { Filters, Leaderboard } from './components';

const defaultFilters = { sport: null };

const DirectionChange = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: ${(props) => (props.isMobile ? 'start' : 'center')};
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
  padding: ${(props) => (props.isMobile ? '16px 0 0' : '40px 0 0')};
  width: 100%;
`;

let timer, timer2;
const Shoutout = ({}) => {
  const [text, setText] = useState(''),
    [filters, setFilters] = useState({ sport: null }),
    [loading, setLoading] = useState(false),
    storeData = useSelector((state) => state.shoutout) || {},
    { games = [], shoutouts = [] } = storeData,
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    dispatch = useDispatch();

  useEffect(() => {
    // Update live games interval
    updateGames('shoutout');
    timer2 = setInterval(() => updateGames('shoutout'), 30000);

    onInitialRender();
  }, []);

  async function onInitialRender() {
    if (!games?.length || !shoutouts?.length) setLoading(true);
    await getData();
    setLoading(false);
  }

  async function onTextChange(val) {
    setText(val);
    clearTimeout(timer);

    timer = setTimeout(async () => {
      const res = await getData({ text: val, skip: 0 });
    }, 300);
  }

  async function onFilterChange({ type, values }) {
    clearTimeout(timer);

    if (!values) {
      setFilters(defaultFilters);
    } else {
      let newFilters = filters;
      newFilters[type] = values;
      clearTimeout(timer);
      setFilters(newFilters);
    }

    timer = setTimeout(async () => {
      const res = await getData({
        text,
        sports: type === 'sport' ? values : [],
        skip: 0
      });
    }, 300);
  }

  async function getData(params) {
    const res = await Api.post('/shoutouts/get', params);
    if (!res) return;

    dispatch({
      type: 'SET_SHOUTOUT',
      payload: res
    });

    dispatch({
      type: 'ADD_SHOUTOUTS',
      payload: res.shoutouts || []
    });
  }

  return (
    <Row centerAll wid="100%">
      <Col wid={isMobile ? '100vw' : '936px'} noFlex center pad="0 0 84px">
        <DirectionChange isMobile={isMobile}>
          <Col centerAll={isMobile} noFlex wid={isMobile && '100%'}>
            <Input
              search
              placeholder={t('common.search')}
              value={text}
              onChange={({ target }) => onTextChange(target.value)}
              wid={isMobile ? 'calc(100% - 32px)' : '296px'}
              marg={isMobile ? '0 0 16px 0' : '0 24px 0 0'}
            />
          </Col>

          <Filters onFilterChange={onFilterChange} />
        </DirectionChange>

        {loading ? (
          <Col wid="100%" marg="32px 0 0" noFlex centerAll>
            <Spinner2 />
          </Col>
        ) : (
          <Col marg={isMobile ? '16px 0' : '32px 0'} gap="40px">
            <Games data={games} marg="0" />

            <ShoutoutsRow marg="0" title={t('browse.trendingShoutouts')} data={shoutouts} />

            <Leaderboard />
          </Col>
        )}
      </Col>
    </Row>
  );
};

export default Shoutout;
